import { useSelector } from "react-redux";


export const ErrorMessage = () => {
    let errorMessage = useSelector((state) => state.error.message);
    let obj = {
        errorMessage,
        error: null
    }
    
    return obj
}